import { render, staticRenderFns } from "./ContactMailIcon.vue?vue&type=template&id=723dc7c9&scoped=true&"
import script from "./ContactMailIcon.vue?vue&type=script&lang=js&"
export * from "./ContactMailIcon.vue?vue&type=script&lang=js&"
import style0 from "./ContactMailIcon.vue?vue&type=style&index=0&id=723dc7c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723dc7c9",
  null
  
)

export default component.exports